/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AlertApiConfiguration } from '../alert-api-configuration';
import { BaseService } from '../base-service';
import { StrictHttpResponse } from '../strict-http-response';

import { GetDisasters$Params, getDisasters } from '../fn/disaster-list/get-disasters';
import { Disasters } from '../models/disasters';

/**
 * Disaster list API
 */
@Injectable({ providedIn: 'root' })
export class DisasterListService extends BaseService {
   constructor(config: AlertApiConfiguration, http: HttpClient) {
      super(config, http);
   }

   /** Path part for operation `getDisasters()` */
   static readonly GetDisastersPath = '/api/alert/disaster/list';

   /**
    * This method provides access to the full `HttpResponse`, allowing access to response headers.
    * To access only the response body, use `getDisasters()` instead.
    *
    * This method doesn't expect any request body.
    */
   getDisasters$Response(
      params?: GetDisasters$Params,
      context?: HttpContext
   ): Observable<StrictHttpResponse<Disasters>> {
      return getDisasters(this.http, this.rootUrl, params, context);
   }

   /**
    * This method provides access only to the response body.
    * To access the full response (for headers, for example), `getDisasters$Response()` instead.
    *
    * This method doesn't expect any request body.
    */
   getDisasters(params?: GetDisasters$Params, context?: HttpContext): Observable<Disasters> {
      return this.getDisasters$Response(params, context).pipe(
         map((r: StrictHttpResponse<Disasters>): Disasters => r.body)
      );
   }
}
